import { render, staticRenderFns } from "./RefugioMapInfo.vue?vue&type=template&id=6760f4fc&scoped=true&lang=pug&"
import script from "./RefugioMapInfo.vue?vue&type=script&lang=js&"
export * from "./RefugioMapInfo.vue?vue&type=script&lang=js&"
import style0 from "./RefugioMapInfo.vue?vue&type=style&index=0&id=6760f4fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760f4fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VTab,VTabItem,VTabs})
